import { render, staticRenderFns } from "./TransferEditor.vue?vue&type=template&id=546d66b7&"
import script from "./TransferEditor.vue?vue&type=script&lang=js&"
export * from "./TransferEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports